// extracted by mini-css-extract-plugin
export default {"root":"Suppliers_root__5TWoy","link":"Suppliers_link__YKjDc","Suppliers":"Suppliers_Suppliers__EzyMo"};